import Vue from 'vue'

// Lib imports
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_URL

Vue.prototype.$http = axios

Vue.prototype.$crmHttp = axios.create({
  baseURL: process.env.VUE_APP_CRM_URL,
})

Vue.prototype.$amsHttp = axios.create({
  baseURL: process.env.VUE_APP_AMS_URL,
})
